/**
 * Adapted form prosemirror-markdown.
 *
 * Here we can override some files to change how markdown is turned into a ProseMirror document.
 */

import MarkdownIt from "markdown-it";
import { ParseSpec, MarkdownParser } from "prosemirror-markdown";
import { Transform } from "prosemirror-transform";
import { Node, Schema } from "prosemirror-model";

// If we want to make changes that fit within the markdown spec, they can
// be defined here. This is a bit easier than redefining the whole markdown
// parser.
const postProcessDocument = (doc: Node): Node => {
    const taskTransform = new Transform(doc);
    doc.descendants((node, pos) => {
        if (node.type.name === "list_item" && node.attrs?.["isToDoItem"]) {
            const itemStartPos = taskTransform.mapping.map(pos);
            taskTransform.deleteRange(itemStartPos, itemStartPos + 6);
        }
    });
    return taskTransform.doc;
};

export const parseDocument = (
    markdownText: string,
    parseSpecs: { [name: string]: ParseSpec },
    markdownIt: MarkdownIt,
    schema: Schema
): Node => {
    const markdownParser = new MarkdownParser(schema, markdownIt, parseSpecs);
    const document = markdownParser.parse(markdownText);
    return postProcessDocument(document);
};
